import PropTypes from 'prop-types';
import Login from '@cont/Login/Login';
import { useState } from 'react';
import useCountries from '@api/hooks/useCountries';
import {
  StyledPaper,
  ClassTitle,
  ClassSubTitle,
  Fire,
  Flex,
  BookAClassForm,
  RequeestOtpForm,
  OTPFooterTitle,
  OTPFooterEmail,
  BookAClassContainer,
  OTPFooter,
  OTPEmailText
} from './styles';
import Form from './Form';

const BookAClass = ({
  state,
  dispatch,
  handleSourceLogin,
  heroForm,
  getGoalName
}) => {
  const OTPText = 'Having trouble? Write us on';
  const OTPEmail = 'help@unacademy.com';
  const { title, subTitle, url } = heroForm.header;
  const { name, email, phoneNumber, form } = state;
  const bookForm = ['BOOK_FORM', 'CLASS_BOOKED'].includes(form);
  const loginForm = form === 'LOGIN_FORM';
  const updateForm = (type) => {
    dispatch({
      type: 'SET_FORM',
      payload: type || (loginForm ? 'BOOK_FORM' : 'LOGIN_FORM')
    });
  };

  const defaultCountry = {
    code: 'IN',
    name: 'India',
    flagIconUrl: 'https://static.uacdn.net/thumbnail/country-flag-icons/in.png',
    phoneCode: '91'
  };

  const countries = useCountries();

  const [country, setCountry] = useState(
    countries.length
      ? countries.find((c) => c.code === 'IN') || defaultCountry
      : defaultCountry
  );

  const changeCountry = (countryOption) => {
    setCountry(countries.find((c) => c.code === countryOption.value));
  };
  return (
    <BookAClassContainer>
      <StyledPaper>
        <BookAClassForm $display={bookForm}>
          <ClassTitle>{title}</ClassTitle>
          {subTitle ? (
            <Flex>
              <Fire src={url.default} alt="fire" width="14px" height="14px" />
              <ClassSubTitle>{subTitle}</ClassSubTitle>
            </Flex>
          ) : null}
          <Form
            changeCountry={changeCountry}
            country={country}
            countries={countries}
            getGoalName={getGoalName}
            updateForm={updateForm}
            state={state}
            dispatch={dispatch}
            heroForm={heroForm}
          />
        </BookAClassForm>
        <RequeestOtpForm $display={loginForm}>
          {loginForm && (
            <>
              <Login
                countrySelected={country}
                countryAlreadyPresent
                source="page"
                showOtpField
                phoneNumber={phoneNumber}
                hideHelp
                sourceType="marketing"
                updateForm={updateForm}
                handleSourceLogin={handleSourceLogin}
                userInfo={{ name, email, phoneNumber }}
              />
              <OTPFooter>
                <OTPFooterTitle>{OTPText}</OTPFooterTitle>
                <OTPFooterEmail href="mailTo:help@unacademy.com">
                  <OTPEmailText>{OTPEmail}</OTPEmailText>
                </OTPFooterEmail>
              </OTPFooter>
            </>
          )}
        </RequeestOtpForm>
      </StyledPaper>
    </BookAClassContainer>
  );
};

BookAClass.propTypes = {
  handleSourceLogin: PropTypes.func.isRequired,
  state: PropTypes.objectOf(PropTypes.any).isRequired,
  dispatch: PropTypes.func.isRequired,
  heroForm: PropTypes.objectOf(PropTypes.any).isRequired
};

export default BookAClass;
